import type { JSX } from 'react';
import React, { Fragment } from 'react';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { EMouseLeaveDelay, Tooltip } from '@feathr/components';

import type { IPlatformOption } from './MetaChannelSettingsCard.hooks';

import * as styles from './MetaPlatformOption.css';

function MetaPlatformOption(props: OptionProps<IPlatformOption>): JSX.Element {
  const {
    data: { id, name, tooltip },
  } = props;
  const option = (
    <components.Option {...props}>
      <Fragment key={id}>{name}</Fragment>
    </components.Option>
  );
  return tooltip ? (
    <Tooltip className={styles.tooltipWrapper} closeDelay={EMouseLeaveDelay.Link} title={tooltip}>
      {option}
    </Tooltip>
  ) : (
    option
  );
}

export default MetaPlatformOption;
